import { useAuth0 } from "@auth0/auth0-react";
import { DatePickerField } from "_metronic/_partials/controls";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import { InputField, LabelField, MyCheckbox, SelectField } from "components";
import AlertDialog from "components/Dialog";
import InfoTooltip from "components/InfoTooltip";
import AddInstallmentsPayment from "components/Installments/AddInstallmentsPayment";
import { TextareaField } from "components/TextareaField";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import { useSearch } from "hook";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import FinanceService from "../../../../Lib/API/Finance";
import { CheckFloatValue } from "../../../../utils/functions";
import { PriceType } from "./PercentageFixed";

const CreditOnAccount = ({
  types,
  setShow,
  show,
  index,
  removeCharge,
  accountName,
  setAccountName,
  enableInstallments,
  ...props
}) => {
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  const formik = props;
  const [loading, setLoading] = React.useState(false);
  const [taxType, setTaxType] = useState("%");
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [ledgers, setLedgers] = useState();
  const [data, setData] = useState();
  const { getAccessTokenSilently } = useAuth0();
  const [subLedgerOptions, setSubLedgerOptions] = useState();
  const [localFormat, setLocalFormat] = useState(false);
  const { accountTransaction } = useSelector((state) => state.CommonStates);
  const [defaultLedger, setDefaultLedger] = useState(null);
  const [defaultSubLedger, setDefaultSubLedger] = useState(null);
  const [pendingLedger, setPendingLedger] = useState(null);
  const [showLedgerConfirm, setShowLedgerConfirm] = useState(false);
  const [pendingSubLedger, setPendingSubLedger] = useState(undefined);
  const [showSubLedgerConfirm, setShowSubLedgerConfirm] = useState(false);

  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const dateTimeMask = maskDate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");


  useEffect(() => {
    formik.setFieldValue("type_of_charge", "credit_on_account");
    if (formik.values?.nextPayment === false && accountName === true) {
      formik.setFieldValue(`values.${index}.Ledger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.SubLedger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.tax`, "");
      formik.setFieldValue(`values.${index}.total_amount`, "");
      formik.setFieldValue(`values.${index}.discount`, "");
      formik.setFieldValue(`values.${index}.note`, "");
    }
    if (!!accountTransaction) {
      formik.setFieldValue(`account_name`, {
        id: accountTransaction?._id,
        name: accountTransaction?.family_name,
      });
    }
  }, []);

  // const total = useMemo(() => {
  //   const acutalTotal = formik.values.values.reduce((a, b) => {
  //     return a + (b?.total_amount ?? 0);
  //   }, 0);
  //   const totalAmount = formik.values.values.reduce((a, b) => {
  //     const getTotalAmount = a + (b?.total_amount ?? 0);

  //     // const getFinalAmount =
  //     //   b?.tax_type === "%" && getTaxValue > 1
  //     //     ? getTotalAmount +
  //     //       (getTotalAmount / 100) * (getTaxValue < 1 ? 0 : getTaxValue)
  //     //     : getTotalAmount + getTaxValue;

  //     return getTotalAmount;
  //   }, 0);
  //   formik.setFieldValue("current_total", totalAmount);
  //   formik.setFieldValue("actual_total", acutalTotal);
  //   return Number.isNaN(totalAmount) ? 0 : totalAmount;
  // }, [formik.values.values]);

  const getDiscountValue = formik?.values?.values.reduce((a, b) => {
    return a + parseInt(b?.discount ? b?.discount : "0");
  }, 0);

  const total = useMemo(() => {
    const acutalTotal = formik.values.values.reduce((a, b) => {
      return (
        a + (parseFloat(b?.total_amount === "" ? 0 : b?.total_amount) ?? 0)
      );
    }, 0);

    const totalAmount = formik.values.values.reduce((a, b) => {
      const getTotalAmount = a + (b?.total_amount ?? 0);

      var numVal1 = Number(acutalTotal);
      var numVal2 = Number(getDiscountValue) / 100;
      var totalValue = numVal1 - numVal1 * numVal2;

      const getValueAfterDiscount =
        b?.discount_type === "%" ? totalValue : acutalTotal - getDiscountValue;

      return getValueAfterDiscount;
    }, 0);

    if (getDiscountValue > 0) {
      formik.setFieldValue("actual_total", acutalTotal);
    } else {
      formik.setFieldValue("actual_total", acutalTotal);
    }
    // formik.setFieldValue("current_total", totalAmount);
    // formik.setFieldValue("actual_total", acutalTotal);

    return Number.isNaN(totalAmount) ? 0 : totalAmount;
  }, [formik.values.values]);

  const changeAmount = useMemo(() => {
    const formikValues = formik.values?.values[0];
    const newAmount =
      formikValues.split_duration === "day"
        ? total / formikValues.number_of_split
        : formikValues.split_duration === "week"
          ? total / (formikValues.number_of_split * 7)
          : formikValues.split_duration === "month"
            ? total / (formikValues.number_of_split * 30)
            : formikValues.split_duration === "quarter"
              ? total / (formikValues.number_of_split * 90)
              : formikValues.split_duration === "year"
                ? total / (formikValues.number_of_split * 365)
                : "";

    formik.setFieldValue("split_amount", newAmount);
    return Number.isNaN(newAmount) ? 0 : newAmount;
  }, [formik.values.values]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const getCommaSeperatedValue = (num) => {
    return (
      CheckFloatValue(parseFloat(num?.toString()?.replace(/,/g, "")))
        ?.toString()
        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];
  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  // commits
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const enableLoading = (value) => {
    setLoading(value);
  };



  const checkDefault = (ledgers) => {
    let defaultLedger = null;
    let defaultSubLedger = null;
    let subLedgerOptions = null;
    ledgers.forEach((item) => {
      if (item?.defaultCOA) {
        defaultLedger = item;
        subLedgerOptions = item?.sub_ledgers;
        getLedgerSubLedgerListById(item);
      } else if (item?.sub_ledgers?.length) {
        item.sub_ledgers.forEach((subLedger) => {
          if (subLedger?.defaultCOA) {
            defaultLedger = item;
            defaultSubLedger = subLedger;
            subLedgerOptions = item?.sub_ledgers;
            getLedgerSubLedgerListById(item);
            onSubledgerChange(subLedger);
          }
        });
      }
    });
    !defaultLedger && toastr.error("Error", "No default ledger found")
   setDefaultLedger(defaultLedger);
   setDefaultSubLedger(defaultSubLedger);
    setSubLedgerOptions(subLedgerOptions);
  };


  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, search)
        .then((res) => {
          if (res?.accounts) {
            res.accounts.map((item) => {
              item.label = item.family_name;
              item.value = item.account_id;
              return item;
            });
            setData(res?.accounts);
          }
          enableLoading(false);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    async function getLedgeraccounts() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if(formik.values.type !== "edit-charge") {
        checkDefault(res?.ledgers);
      }
      if (res?.ledgers) {
        setLedgers(res?.ledgers);
      }
      enableLoading(false);
    }
    getLedgeraccounts();
    fetchMyAPI();
  }, [search, getAccessTokenSilently]);
  const getLedgerSubLedgerListById = async (event) => {
    formik.setFieldValue(`values.${index}.Ledger`, {
      id: event._id || event.value,
      name: event.ledger_name || event.label,
      account_receivable: event?.account_receivable,
    });
    const ksubLedgers = ledgers?.find((item) => (event.value || event._id) === item._id);
    setSubLedgerOptions(ksubLedgers?.sub_ledgers);
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: "",
      name: "",
    });
    formik.setFieldValue(`values.${index}.tax`, event?.amount_detuctible);
    if (formik.values.type !== "edit-charge") {
      formik.setFieldValue(`values.${index}.total_amount`, event?.default_amount);
    }
    formik.setFieldValue(`convenient_fee`, event?.gateway_fee);
    formik.setFieldValue(`require_notes`, event?.notes);



  };
  const onSubledgerChange = (e) => {
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: e._id || e.value,
      name: e.sub_ledger_name || e.label,
    });
    formik.setFieldValue(`values.${index}.tax`, e?.amount_detuctible);
    if (formik.values.type !== "edit-charge") {
      formik.setFieldValue(`values.${index}.total_amount`, e?.default_amount);
    }
    formik.setFieldValue(`convenient_fee`, e?.gateway_fee);
    formik.setFieldValue(`require_notes`, e?.notes);
  };

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item?.ledger_name,
        value: item?._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
        account_receivable: item?.account_receivable,
      };
    });
  const subLedgersList =
    subLedgerOptions &&
    subLedgerOptions?.map((item) => {
      return {
        label: item.sub_ledger_name,
        value: item._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
      };
    });

  // const [calculatedAmount, setCalculatedAmount] = useState("00");
  let commingAmount = formik.values?.values?.[index]?.charge?.amount
    ? formik.values?.values?.[index]?.charge?.amount
    : formik?.values?.allData
      ? formik?.values?.allData[0].total_amount
      : formik.values?.values?.[index]?.total_amount
        ? formik.values?.values?.[index]?.total_amount
        : "";
  // useEffect(() => {
  //   let finalTax =
  //     formik?.values?.values?.[index]?.tax_type == "%"
  //       ? ((formik?.values?.values?.[index]?.tax / 100) * commingAmount)
  //           ?.toFixed(2)
  //           ?.replace("-", "")
  //       : formik?.values?.values?.[index]?.tax?.toFixed(2)?.replace("-", "");
  //   let finalAmount = formik?.values?.values?.[index]?.tax
  //     ? Number(finalTax)
  //     : 0 + commingAmount
  //     ? commingAmount
  //     : 0;
  //   setCalculatedAmount(finalAmount);
  // }, [formik.values]);




  const displayLedgerValue = () => {
    if(formik.values.type === "edit-charge") {
        return {
        label: formik.values?.values?.[index]?.Ledger ? (
          formik.values?.values?.[index]?.Ledger?.name
        ) : (
          <span style={{ color: "#b5b5c3" }}> Select</span>
        ),
        value: formik.values?.values?.[index]?.Ledger?.id,
      }
    } else {
      return  options?.find((item) => item?.value === defaultLedger?._id) || {}
    }
}
  const displaySubLedgerValue = () => {
    if(formik.values.type === "edit-charge") {
      return {
        label: formik.values?.values?.[index]?.SubLedger ? (
          formik.values?.values?.[index]?.SubLedger?.name
        ) : (
          <span style={{ color: "#b5b5c3" }}> Select</span>
        ),
        value: formik.values?.values?.[index]?.SubLedger?.id,
      }
    } else {
      return subLedgersList?.find((item) => item?.value === defaultSubLedger?._id) || {}
    }
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const disabledInstallment = useCallback(() => {
    if(formik.values.values[index]?.ChargeStatus === "close" && (+formik?.values?.actual_total - (+formik?.values?.totalPaid || 0)) <= 0
    || formik.values.values[index]?.ChargeStatus === "close" && (+formik?.values?.actual_total - +formik?.values?.current_amount) <= 0) {
      return true;
    }
    return false;
  }, [formik?.values?.actual_total, formik?.values?.totalPaid, formik?.values?.current_amount]);

  const disabledInstallmentPayment = disabledInstallment();


  return (
    <div className="renderd-comp">
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="charge-tab col-sm-12 px-sm-15 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div
                className="form-group"
                style={{
                  zIndex: "1111",
                }}
              >
                <LabelField mandatory title={"Account Name"} />
                <div style={formik.values.type === "edit-charge" ? { cursor: "not-allowed" } : {}}>
                <Select
                  {...{
                    formik,
                    name: `account_name`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={data}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    formik.setFieldValue(`account_name`, {
                      id: value._id,
                      name: value.label,
                    });
                  }}
                  value={
                    accountTransaction
                      ? {
                        label: accountTransaction?.family_name,
                        value: accountTransaction?._id,
                      }
                      : formik.values?.account_name
                        ? {
                          label: formik.values?.account_name?.name,
                          value: formik.values?.account_name?.id,
                        }
                        : ""
                  }
                  components={{ DropdownIndicator }}
                  isDisabled={formik.values.type === "edit-charge" ? true : index > 0 || !!accountTransaction}
                />
                </div>
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title="Transaction Type" />
                <div className={formik.values.type === "edit-charge" ? "disabledDiv charge-type" : "charge-type"}>
                  {types.map((type, idx) => {
                    const isSelected = type === show;
                    const isCOASelected = show === "Credit On Account";
                    const isCOA = type === "Credit On Account";
                    const isEditMode = formik.values.type === "edit-charge";
                    const isDisabledOption = !isSelected && isEditMode && (isCOASelected || isCOA);
                    return <span
                      className={
                        type === "Credit On Account" ? "col-sm-6" : "col-sm-3"
                      }
                      style={
                        isSelected
                          ? { background: "#2555ef", color: "white" }
                          : isDisabledOption
                            ? { color: "#b0b0b0", cursor: "not-allowed" }
                            : {}
                      }
                      key={idx}
                      onClick={() => {
                        if (formik.values.type === "edit-charge") {
                          toastr.error("You can not change type")
                        } else {
                          setShow(type);
                          setAccountName(true);
                          formik.setFieldValue(
                            `values.${index}.isRecurring`,
                            false,
                          );
                          formik.setFieldValue(
                            `values.${index}.is_splitted`,
                            false,
                          );
                          formik.setFieldValue(
                            `values.${index}.charge_type`,
                            type === "Credit On Account" ? "credit_on_account" : type.toLowerCase()

                          );
                        }
                      }}
                      {...{
                        formik,
                        value: formik.values.values?.[index]?.charge_type,
                      }}
                    >
                      {type}
                    </span>;
                  })}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              {formik.values.type === "edit-charge" ? (
                <div className="form-group">
                  <LabelField title={"Date"} mandatory />
                  <div style={{ cursor: "not-allowed" }}>
                    <div style={{ pointerEvents: "none" }}>
                      <DatePicker
                        showIcon
                        placeholderText={placeholderFormat}
                        dateFormat={dateFormate}
                        selected={
                          formik.values.values?.[index]?.payment_date
                            ? convertUTCToLocalDate(formik.values.values?.[index]?.payment_date)
                            : null
                        }
                        onChange={(e) => {
                          formik.setFieldValue(`values.${index}.payment_date`, e);
                          convertLocalToUTCDate(e, `values.${index}.payment_date`);
                        }}
                        disabled={true}
                        customInput={
                          <MaskedInput
                            pipe={autoCorrectedDatePipe}
                            mask={dateTimeMask}
                            keepCharPositions={true}
                            guide={true}
                          />
                        }
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <DatePickerField
                  disabled={true}
                  mandatory
                  {...{
                    formik,
                    name: `values.${index}.payment_date`,
                    title: "Date",
                    checkValidation: false,
                  }}
                  value={formik.values.values?.[index]?.payment_date}
                  newDate={"newDate"}
                  financeDateFields="finance_datefield"
                />
              )}
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.Ledger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={options}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(e) => {
                    if (formik.values.type === "edit-charge") {
                      setPendingLedger(e);
                      setShowLedgerConfirm(true);
                    } else {
                      getLedgerSubLedgerListById(e);
                    }
                  }}
                  value={displayLedgerValue()}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.SubLedger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLedgersList}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(e) => {
                    if (formik.values.type === "edit-charge") {
                      setPendingSubLedger(e);
                      setShowSubLedgerConfirm(true);
                    } else {
                      onSubledgerChange(e);
                    }
                  }}
                  value={displaySubLedgerValue()}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
              <InputField
                mandatory
                type="number"
                {...{
                  formik,
                  title: "Amount",
                  name: `values.${index}.total_amount`,
                  placeholder: "Charge Amount",
                  value: formik.values?.values?.[index]?.total_amount,
                }}
                min="0"
                onKeyDown={(e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                  if (e.which === 38 || e.which === 40) e.preventDefault();
                }}
                handleChange={(e) => {
                  formik.setFieldValue(
                    `values.${index}.total_amount`,
                    e.target.value.match(regex)[0]
                  );
                }}
              />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5 d-flex">
              <Col className="col-sm-6 px-0">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Tax Deductible",
                    name: `values.${index}.tax`,
                    placeholder: "Tax",
                    value: formik.values?.values?.[index]?.tax ?? "0",
                  }}
                  min="0"
                  onKeyDown={(e) => {
                    exceptThisSymbols.includes(e.key) && e.preventDefault();
                    if (e.which === 38 || e.which === 40) e.preventDefault();
                  }}
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `values.${index}.tax`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                />
              </Col>

              <Col className="col-12 col-md-5 price-type mt-6">
                {formik.values.type === "edit-charge" ? <></> : <PriceType
                  value={
                    formik.values?.values?.[index]?.tax_type
                      ? formik.values?.values?.[index]?.tax_type
                      : formik?.values?.allData[0].tax_type
                  }
                  handleClick={setTaxType}
                  disabled={formik.values.type === "edit-charge" ? true : false}
                  setFieldValue={formik.setFieldValue}
                  index={index}
                  type={`values.${index}.tax_type`}
                />}
              </Col>
            </Col>
            {enableInstallments && (
              <Col className="col-12 col-md-5 offset-md-2 d-flex align-items-end pb-2 mt-9">
                <div
                  className={formik.values.type === "edit-charge" ? "" : disabledInstallmentPayment ? "disabledDiv" : ""}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <MyCheckbox
                    name={`values.${index}.isInstallmentTransaction`}
                    title="Allow Installments"
                    handlechange={(event) => {
                      formik.setFieldValue(
                        `values.${index}.isInstallmentTransaction`,
                        event.target.checked
                      );
                    }}
                    value={formik.values.values[index]?.isInstallmentTransaction}
                    checked={formik.values?.values[index]?.isInstallmentTransaction}
                    disabled={formik.values.type === "edit-charge" ? false : disabledInstallmentPayment}
                  />
                  <InfoTooltip text="Let the payer spread this charge across multiple scheduled installments instead of paying it all at once. Only monthly installments are currently supported." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
              </Col>
            )}
          </Row>
          {(formik.values.values[index]?.isInstallmentTransaction && enableInstallments) && (
            <Col className="col px-0">
              <AddInstallmentsPayment
                formik={formik}
                formikKey={"installmentDetailsTransaction"}
                onInstallmentChange={(value) => {
                  if(!value) {
                    formik.setFieldValue(`values.${index}.installmentDetailsTransaction.numberOfInstallment`, null);
                    return;
                  }
                  formik.setFieldValue(`values.${index}.installmentDetailsTransaction.numberOfInstallment`, value?.value);
                }}
                onDateChange={(date) => {
                  formik.setFieldValue(`values.${index}.installmentDetailsTransaction.lastInstallmentDate`, date);
                  convertLocalToUTCDate(date, `values.${index}.installmentDetailsTransaction.lastInstallmentDate`);
                }}
                installmentValue={formik.values.values[index]?.installmentDetailsTransaction?.numberOfInstallment}
                dateValue={
                  formik.values.values[index]?.installmentDetailsTransaction?.lastInstallmentDate &&
                  convertUTCToLocalDate(formik.values.values[index]?.installmentDetailsTransaction?.lastInstallmentDate)
                }
                manageFromOutside={true}
                disabled={formik.values.type === "edit-charge" ? false : disabledInstallmentPayment}
              />
            </Col>
          )}
          <Col className="col-sm-12 px-0 mt-10">
            <TextareaField
              // mandatory={formik?.values?.require_notes ? true : false}
              {...{
                formik,
                title: "Add Note",
                name: `values.${index}.note`,
                placeholder: "Note text",
                style: { resize: "none" },
                value: formik?.values?.values?.[index]?.note,
              }}
              defaultValue={
                formik?.values?.note ??
                formik?.values?.allData?.[0]?.comment_invoice?.note
              }
            // disabled={formik.values.type === "edit-charge" ? true : false}
            />
          </Col>
          <hr className="mt-15 mb-7" />
          <div className="d-flex justify-content-end ">
            {formik.values?.values?.length - 1 === index && (
              <p className="charge-total">
                Total: {currency}
                {formik?.values?.actual_total === 0
                  ? "0.00"
                  : formik?.values?.actual_total
                    ? numberFormat({number:+formik.values?.actual_total, decimal:2, style:'decimal'})
                    : formik.values?.current_total
                      ? numberFormat({number:+formik.values?.current_total, decimal:2, style:'decimal'})
                      : formik.values?.values?.[index]?.charge?.amount
                        ? numberFormat({number:+formik.values?.current_amount, decimal:2, style:'decimal'}) ??
                        numberFormat({number:+formik.values?.current_total, decimal:2, style:'decimal'})
                        : formik?.values?.allData
                          ? numberFormat({number:(+formik?.values?.allData[0].total_amount), decimal:2, style:'decimal'})
                          : formik.values?.values?.[index]?.total_amount
                            ? numberFormat({number:+formik.values?.current_amount, decimal:2, style:'decimal'}) ??
                            numberFormat({number:+formik.values?.current_total, decimal:2, style:'decimal'})
                            : "0.00"}
                {formik.values?.current_amount === "0" && "0.00"}
                {
                  /* {calculatedAmount
              ? getCommaSeperatedValue(calculatedAmount)
              :  */
                  // formik.values?.values?.[index]?.total_amount
                  //   ? thousands((+formik.values?.current_total).toFixed(2))
                  //   : "0.00"
                }
              </p>
            )}
            {formik.values?.values?.length === 1 ? (
              ""
            ) : (
              <div className="mt-2 ml-5">
                <a className="text-primary" onClick={() => removeCharge(index)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                  <span className="ml-2">Remove Credit On Account</span>
                </a>
              </div>
            )}
          </div>
        </div>
      </form>
      <AlertDialog
        open={showLedgerConfirm}
        onDecline={() => { setShowLedgerConfirm(false); setPendingLedger(null); }}
        onAccept={() => {
          setShowLedgerConfirm(false);
          if (pendingLedger) getLedgerSubLedgerListById(pendingLedger);
          setPendingLedger(null);
        }}
        title={"Update Ledger"}
        acceptBtnText={"Update"}
        description={
          <div style={{ textAlign: 'left' }}>
            <p style={{ marginBottom: '8px' }}>By clicking update you are aware and agree to the below:</p>
            <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
              <li style={{ marginBottom: '6px' }}>All related transactions and documents will be updated with the new ledger name.</li>
              <li>Your accounting software (if connected) will not be updated. In order to keep the data accurate, you will need to update it manually.</li>
            </ul>
          </div>
        }
      />
      <AlertDialog
        open={showSubLedgerConfirm}
        onDecline={() => { setShowSubLedgerConfirm(false); setPendingSubLedger(undefined); }}
        onAccept={() => {
          setShowSubLedgerConfirm(false);
          if (pendingSubLedger !== undefined) onSubledgerChange(pendingSubLedger);
          setPendingSubLedger(undefined);
        }}
        title={"Update Sub-Ledger"}
        acceptBtnText={"Update"}
        description={
          <div style={{ textAlign: 'left' }}>
            <p style={{ marginBottom: '8px' }}>By clicking update you are aware and agree to the below:</p>
            <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
              <li style={{ marginBottom: '6px' }}>All related transactions and documents will be updated with the new sub-ledger name.</li>
              <li>Your accounting software (if connected) will not be updated. In order to keep the data accurate, you will need to update it manually.</li>
            </ul>
          </div>
        }
      />
    </div>
  );
};

export default CreditOnAccount;